import { Competition } from "@brg/api";
import { BTag, BrgButton, ButtonVariant, FlexBox } from "@brg/ui";
import { bTag, useModal } from "core";
import { useTranslation } from "react-i18next";
import useCompetitionActions from "shared/hooks/useCompetitionActions";
import { ExamTitle, TagsTitle, NoProjectTagChip, NoProjectPortfolioHint } from "./styles";
import { BTagsGridNew } from "core/components/bTag/bTagsGridNew/bTagsGridNew";
import { BrgButtonThin } from "shared/components/buttons";
import { useMemo } from "react";
export const NoProjectPrompt = ({
    competition,
    visibility,
    legalContestFormAfterPublish,
    isAttemptsLimitReached,
}: {
    competition?: Competition;
    visibility: boolean;
    legalContestFormAfterPublish?: boolean;
    isAttemptsLimitReached?: boolean;
}) => {
    const modal = useModal();

    const { t } = useTranslation();

    const {
      openProfile,
      handleCreateProject,
      tagString,
      isPromptCompetition,
      tags,
      isExam
    } = useCompetitionActions(competition);

    const closeModal = () => {
      modal.hide();
    }

    const onCreateProject = () => {
      if (isAttemptsLimitReached) {
        return;
      }
      handleCreateProject?.('_SELF', { legalContestFormAfterPublish })
    }

    const isByCategory = !!(competition as any)?.isByCategory;
    const noProjectDescription = isByCategory
      ? 'dont_have_project_for_category'
      : isPromptCompetition ? 'dont_have_project_for_prompt' : isExam ? 'dont_have_any_project_exam' : 'dont_have_any_project'
    const noProjectHint = isByCategory ? 'no_project_portfolio_or_create_category' : 'no_project_portfolio_or_create'

    const tagChipLabel = useMemo(() => {
      if (tags?.length) {
        return tags.map((tag) => bTag.title(tag)).join(' ');
      }
      return (tagString || '').replace(/#/g, '').replace(/\s+/g, ' ').trim();
    }, [tags, tagString]);


    if (!visibility) return null;

    return <FlexBox width={'100%'} widthMobile={'calc(100% - 32px)'} offsetTop={32} justify='center' align='center' offsetLeftMobile={16} offsetRightMobile={16}>
      <FlexBox direction={'column'} gy={20}>
        <FlexBox direction={'column'} directionMobile='column' width={'100%'} justify={'center'} align={'center'}>
          {isExam && <ExamTitle>{t('need_project.exam_title')}</ExamTitle>}
          <TagsTitle isExam={isExam}>
            {t(`competition_edit.${noProjectDescription}`)}
          </TagsTitle>
          {!isExam && !!tagChipLabel && (
            <NoProjectTagChip>{tagChipLabel}</NoProjectTagChip>
          )}
          {!!tags?.length && isExam && (
            <BTagsGridNew justify='center' style={{ marginTop: '16px' }}>
              {tags?.map((i) => {
                return (
                  <BTag
                    tag={i}
                    educational={i.isEducationTag}
                    isProjectsTag
                    key={i.tagId}
                  >
                    {bTag.title(i)}
                  </BTag>
                )
              })}

            </BTagsGridNew>
          )}
          {isExam ? (
            <FlexBox offsetTop={40} gx={24}>
              <BrgButtonThin variant='secondary' onClick={closeModal}>{t('need_project.back')}</BrgButtonThin>
              {!isAttemptsLimitReached && (
                <BrgButton variant={ButtonVariant.Filled} fullWidth onClick={onCreateProject}>
                  {t('need_project.create')}
                </BrgButton>
              )}
            </FlexBox>
          ) : (
            <>
              <NoProjectPortfolioHint>{t(`competition_edit.${noProjectHint}`)}</NoProjectPortfolioHint>
              <FlexBox  offsetTop={24} gx={24} direction="row" justify="center" align="center" directionMobile="column" gyMobile={16} gxMobile={1} widthMobile={'100%'}>
                <FlexBox widthMobile={'100%'} width={204} justify='center'>
                  <BrgButton fullWidth variant={ButtonVariant.Hollow}  onClick={openProfile}>
                    {t('competition_edit.my_projects')}
                  </BrgButton>
                </FlexBox>
                {!isAttemptsLimitReached && (
                  <FlexBox widthMobile={'100%'} width={284} justify='center'>
                    <BrgButton fullWidth variant={ButtonVariant.Filled}  onClick={onCreateProject}>
                      {t('competition_edit.create_project')}
                    </BrgButton>
                  </FlexBox>
                )}
              </FlexBox>
            </>
          )}
        </FlexBox>
      </FlexBox>
    </FlexBox>;
};
import { Competition } from "@brg/api";
import { BTag, BrgButton, ButtonVariant, FlexBox } from "@brg/ui";
import { bTag, useModal } from "core";
import { useTranslation } from "react-i18next";
import useCompetitionActions from "shared/hooks/useCompetitionActions";
import { ExamTitle, TagsTitle, NoProjectTagChip, NoProjectPortfolioHint } from "./styles";
import { BTagsGridNew } from "core/components/bTag/bTagsGridNew/bTagsGridNew";
import { BrgButtonThin } from "shared/components/buttons";
import { useMemo } from "react";
export const NoProjectPrompt = ({
    competition,
    visibility,
    legalContestFormAfterPublish,
    isAttemptsLimitReached,
}: {
    competition?: Competition;
    visibility: boolean;
    legalContestFormAfterPublish?: boolean;
    isAttemptsLimitReached?: boolean;
}) => {
    const modal = useModal();

    const { t } = useTranslation();

    const {
      openProfile,
      handleCreateProject,
      tagString,
      isPromptCompetition,
      tags,
      isExam
    } = useCompetitionActions(competition);

    const closeModal = () => {
      modal.hide();
    }

    const onCreateProject = () => {
      if (isAttemptsLimitReached) {
        return;
      }
      handleCreateProject?.('_SELF', { legalContestFormAfterPublish })
    }

    const isByCategory = !!(competition as any)?.isByCategory;
    const noProjectDescription = isByCategory
      ? 'dont_have_project_for_category'
      : isPromptCompetition ? 'dont_have_project_for_prompt' : isExam ? 'dont_have_any_project_exam' : 'dont_have_any_project'
    const noProjectHint = isByCategory ? 'no_project_portfolio_or_create_category' : 'no_project_portfolio_or_create'

    const tagChipLabel = useMemo(() => {
      if (tags?.length) {
        return tags.map((tag) => bTag.title(tag)).join(' ');
      }
      return (tagString || '').replace(/#/g, '').replace(/\s+/g, ' ').trim();
    }, [tags, tagString]);


    if (!visibility) return null;

    return <FlexBox width={'100%'} widthMobile={'calc(100% - 32px)'} offsetTop={32} justify='center' align='center' offsetLeftMobile={16} offsetRightMobile={16}>
      <FlexBox direction={'column'} gy={20}>
        <FlexBox direction={'column'} directionMobile='column' width={'100%'} justify={'center'} align={'center'}>
          {isExam && <ExamTitle>{t('need_project.exam_title')}</ExamTitle>}
          <TagsTitle isExam={isExam}>
            {t(`competition_edit.${noProjectDescription}`)}
          </TagsTitle>
          {!isExam && !!tagChipLabel && (
            <NoProjectTagChip>{tagChipLabel}</NoProjectTagChip>
          )}
          {!!tags?.length && isExam && (
            <BTagsGridNew justify='center' style={{ marginTop: '16px' }}>
              {tags?.map((i) => {
                return (
                  <BTag
                    tag={i}
                    educational={i.isEducationTag}
                    isProjectsTag
                    key={i.tagId}
                  >
                    {bTag.title(i)}
                  </BTag>
                )
              })}

            </BTagsGridNew>
          )}
          {isExam ? (
            <FlexBox offsetTop={40} gx={24}>
              <BrgButtonThin variant='secondary' onClick={closeModal}>{t('need_project.back')}</BrgButtonThin>
              {!isAttemptsLimitReached && (
                <BrgButton variant={ButtonVariant.Filled} fullWidth onClick={onCreateProject}>
                  {t('need_project.create')}
                </BrgButton>
              )}
            </FlexBox>
          ) : (
            <>
              <NoProjectPortfolioHint>{t(`competition_edit.${noProjectHint}`)}</NoProjectPortfolioHint>
              <FlexBox  offsetTop={24} gx={24} direction="row" justify="center" align="center" directionMobile="column" gyMobile={16} gxMobile={1} widthMobile={'100%'}>
                <FlexBox widthMobile={'100%'} width={204} justify='center'>
                  <BrgButton fullWidth variant={ButtonVariant.Hollow}  onClick={openProfile}>
                    {t('competition_edit.my_projects')}
                  </BrgButton>
                </FlexBox>
                {!isAttemptsLimitReached && (
                  <FlexBox widthMobile={'100%'} width={284} justify='center'>
                    <BrgButton fullWidth variant={ButtonVariant.Filled}  onClick={onCreateProject}>
                      {t('competition_edit.create_project')}
                    </BrgButton>
                  </FlexBox>
                )}
              </FlexBox>
            </>
          )}
        </FlexBox>
      </FlexBox>
    </FlexBox>;
};
